<template>
	<section v-if="showSection" class="bg-gradient-to-b md:bg-gradient-to-t from-[#F3F7FD]" data-path="sectionsJobs">
		<AdaptiveContainer class="flex justify-between items-center">
			<BaseHeading
				type="h5"
				class="my-9 col-span-full relative before:content-['&nbsp;'] before:block before:absolute before:-bottom-1 before:h-1 before:w-20 before:bg-red-500"
			>
				{{ $t("dailyFavoriteJobs.title") }}
			</BaseHeading>
			<div class="text-sm hidden sm:flex">
				<NuxtLink :to="`/${$i18n.locale}/jobs`" type="grey" class="text-sm">
					{{ $t("allJobs") }}
					<span class="material-icons-outlined pl-2 text-base">arrow_forward</span>
				</NuxtLink>
			</div>
		</AdaptiveContainer>
		<CarouselJobs
			:data-url="dailyFavoriteJobsUrl"
			:data-url-extra="jobsWithoutApplicantsUrl"
			:slideWidth="320"
			@hide-section="showSection = true"
			@has-category-jobs="showFavCategoryTitle = true"
		></CarouselJobs>

		<div class="sm:hidden mb-6">
			<NuxtLink
				:to="`/${$i18n.locale}/jobs`"
				class="w-full flex justify-center items-center bg-dj-blue/5 text-sm text-dj-blue hover:bg-dj-blue/10 active:bg-dj-blue/10 max-w-[320px] mx-auto mb-4 p-3 rounded-normal"
			>
				{{ $t("allJobs") }}
				<span class="material-icons-outlined pl-2">arrow_forward</span>
			</NuxtLink>
		</div>
	</section>
</template>

<script lang="ts">
import { ref, defineComponent } from "vue";

export default defineComponent({
	name: "DailyFavoriteJobs",
	setup() {
		const showSection = ref(true);
		const showFavCategoryTitle = ref(false);
		let dailyFavoriteJobsUrl = `jobs?scope[]=isDailyFavourite`;
		let jobsWithoutApplicantsUrl = `jobs?scope[]=hasApplicants&limit=10`;

		if (globalConfig.isBlue) {
			dailyFavoriteJobsUrl = `${dailyFavoriteJobsUrl}&scope[]=isBlue`;
			jobsWithoutApplicantsUrl = `${jobsWithoutApplicantsUrl}&scope[]=isBlue`;
		}

		if (globalConfig.isNotBlueHU) {
			dailyFavoriteJobsUrl = `${dailyFavoriteJobsUrl}&scope[]=isNotBlue`;
			jobsWithoutApplicantsUrl = `${jobsWithoutApplicantsUrl}&scope[]=isNotBlue`;
		}

		return {
			showSection,
			showFavCategoryTitle,
			dailyFavoriteJobsUrl,
			jobsWithoutApplicantsUrl,
		};
	},
});
</script>
